/* ============ Intro: plays once per visit ============ */
(function () {
  var intro = $('#intro');
  if (!intro) return;

  var seen = false;
  try { seen = sessionStorage.getItem('rooted-intro') === '1'; } catch (e) {}

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (seen || reduce) {
    intro.classList.add('is-done');
    return;
  }

  window.rootedIntroPending = true;
  var finished = false;

  function done() {
    if (finished) return;
    finished = true;
    intro.classList.add('is-done');
    window.rootedIntroPending = false;
    try { sessionStorage.setItem('rooted-intro', '1'); } catch (e) {}
    setTimeout(function () {
      if (window.rootedAfterIntro) window.rootedAfterIntro();
    }, 250);
  }

  intro.addEventListener('click', done);
  setTimeout(done, 2400);
})();
